content-tabs {
  display: block;
  button[role="tab"] {
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    background-color: inherit;
    cursor: pointer;    
    border-bottom: 1px solid transparent;
    &[aria-selected="true"] {
      border-bottom: 1px solid black;
    }
  }
}
